import React from "react";
import ModalBasic from "../../pages/component/ModalBasic";

export default function EventRegistrationApprovalDetailsModel(props) {
  return (
    <div className="event-registration-popup">
      <ModalBasic
        id="cancel-booking-modal"
        className="cancel-booking-modal"
        modalOpen={props.setRegistrationApprovalModel}
        setModalOpen={props.setOpenModal}
        title="Event Registration Approval Details"
      >
         <div className="event-registration-model">
          <div className="event-registration-model-list">
            <h2 className="key">Event Name :</h2>
            <h2 className="value"> {props.singleEventApprovalDetails.eventName}</h2>
          </div>
          <div className="event-registration-model-list">
            <h2 className="key">Event Date :</h2>
            <h2 className="value"> {props.singleEventApprovalDetails.timeSlotDate}</h2>
          </div>
          <div className="event-registration-model-list">
            <h2 className="key">Participant Name :</h2>
            <h2 className="value">  {props.singleEventApprovalDetails.contactPerson}</h2>
          </div>
          <div className="event-registration-model-list">
            <h2 className="key">Email :</h2>
            <h2 className="value"> {props.singleEventApprovalDetails.email}</h2>
          </div>
          <div className="event-registration-model-list">
            <h2 className="key">Company Name :</h2>
            <h2 className="value"> {props.singleEventApprovalDetails.companyName}</h2>
          </div>
          <div className="event-registration-model-list">
            <h2 className="key">Job Title :</h2>
            <h2 className="value">  {props.singleEventApprovalDetails.title}</h2>
          </div>
          <div className="event-registration-model-list">
            <h2 className="key">Status :</h2>
            <h2 className="value"> {props.singleEventApprovalDetails.bookingStatus}</h2>
          </div>
        </div>
      </ModalBasic>
    </div>
  );
}
